<ins-cookie-settings>
    <!-- prettier-ignore -->
    <div slot="main">
        <p class="h2" i18n="@@feature-cookie.modal.title" id="dialog-title">InShared uses cookies</p>
        <p>
            We gebruiken cookies om u beter en persoonlijker te helpen als u contact met ons heeft. Bijvoorbeeld via de
            website, social media of advertenties die u tegenkomt. Dat doen we door het analyseren en combineren van uw
            online gedrag met de persoonsgegevens die u online achterlaat en bij ons bekend zijn. We werken hiervoor
            samen met andere bedrijven. Ook buiten Europa.
            Lees meer over <a [href]="baseUrl + '/cookies'">cookies</a> of ons
            <a [href]="baseUrl + '/privacy'">privacystatement</a>.
        </p>

        <div class="cookie-settings__information">
            <wuc-link
                [noWrap]="true"
                (clicked)="onMoreInfoClick(cookieConsent.All)"
                [class.cookie-settings__link--selected]="moreInfoOpened === cookieConsent.All"
            >
                <div>
                    <span i18n="@@feature-cookie.modal.more-info-link-all">More information about agreement</span>
                    <wuc-icon-ui
                        class="cookie-settings__link-icon"
                        type="secondary"
                        [icon]="moreInfoOpened === cookieConsent.All ? 'up-open' : 'bottom-open'"
                    ></wuc-icon-ui>
                </div>
            </wuc-link>
            <div
                class="cookie-settings__consent-all-info"
                *ngIf="moreInfoOpened === cookieConsent.All">
                <wuc-balloon
                    arrowPosition="topLeft"
                    backgroundStyle="secondary"
                    padding="medium"
                >
                    <div class="cookie-settings__lists">
                        <div class="cookie-settings__list">
                            <div class="h4">Wat doen we wel</div>
                            <wuc-list icon="dot-small">
                                <wuc-list-item>Cookies gebruiken zodat deze website goed werkt</wuc-list-item>
                                <wuc-list-item>Anonieme statistieken bijhouden</wuc-list-item>
                                <wuc-list-item>Een premieberekening en/of aanmelding meten</wuc-list-item>
                                <wuc-list-item>Gebruikersonderzoek</wuc-list-item>
                                <wuc-list-item>Persoonlijke statistieken bijhouden</wuc-list-item>
                                <wuc-list-item>Informatie op maat tonen</wuc-list-item>
                                <wuc-list-item>Adverteren op andere websites en sociale media, o.a. vanuit informatie over
                                    uw bezoek
                                </wuc-list-item>
                            </wuc-list>
                        </div>
                    </div>
                </wuc-balloon>
            </div>
            <wuc-link
                [noWrap]="true"
                (clicked)="onMoreInfoClick(cookieConsent.Basic)"
                [class.cookie-settings__link--selected]="moreInfoOpened === cookieConsent.Basic"
            >
                <div>
                    <span i18n="@@feature-cookie.modal.more-info-link-basic">More information about refusing</span>
                    <wuc-icon-ui
                        class="cookie-settings__link-icon"
                        type="secondary"
                        [icon]="moreInfoOpened === cookieConsent.Basic ? 'up-open' : 'bottom-open'"
                    ></wuc-icon-ui>
                </div>
            </wuc-link>
            <div
                class="cookie-settings__consent-basic-info"
                *ngIf="moreInfoOpened === cookieConsent.Basic">
                <wuc-balloon
                    arrowPosition="topLeft"
                    backgroundStyle="secondary"
                    padding="medium"
                >
                    <div class="cookie-settings__lists">
                        <div class="cookie-settings__list">
                            <div class="h4">Wat doen we wel</div>
                            <wuc-list icon="dot-small">
                                <wuc-list-item>Cookies gebruiken zodat deze website goed werkt</wuc-list-item>
                                <wuc-list-item>Anonieme statistieken bijhouden</wuc-list-item>
                                <wuc-list-item>Een premieberekening en/of aanmelding meten</wuc-list-item>
                            </wuc-list>
                        </div>
                        <div class="cookie-settings__divider"></div>
                        <div class="cookie-settings__list">
                            <div class="h4">Wat doen we niet</div>
                            <wuc-list icon="dot-small">
                                <wuc-list-item>Gebruikersonderzoek</wuc-list-item>
                                <wuc-list-item>Persoonlijke statistieken bijhouden</wuc-list-item>
                                <wuc-list-item>Informatie op maat tonen</wuc-list-item>
                                <wuc-list-item>Gepersonaliseerd adverteren op basis van uw websitebezoek</wuc-list-item>
                            </wuc-list>
                        </div>
                    </div>
                </wuc-balloon>
            </div>
        </div>

        <p class="h3">Akkoord?</p>
        <p>
            U geeft dan toestemming voor het plaatsen van analytische, affiliate, feedback, advertentie en
            personalisatie cookies en het verwerken van uw persoonsgegevens. Wilt u dit niet? Dan kunt u kiezen voor
            "Weigeren". Functionele cookies zonder invloed op uw privacy plaatsen wij altijd.
        </p>

        <p class="h3">Weigeren?</p>
        <p>
            Dan plaatsen wij uitsluitend functionele cookies. Functionele cookies plaatsen wij altijd.
        </p>
    </div>
</ins-cookie-settings>
